(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeSocialHistoryComponent', psychIntakeSocialHistoryComponent);

    psychIntakeSocialHistoryComponent.$inject = [];

    function psychIntakeSocialHistoryComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeSocialHistoryController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/social-history.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeSocialHistoryController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeSocialHistoryController($scope, $stateParams, $element) {
        var vm = this;

        function init() {}

        init();
    }
})();
